export const translations = {
  locale: 'en',
  SettingsFeesApp: {
    CLIENT_FEES_HEADER: '预设的客户费用',
    ACCOUNT_FEES_HEADER: '我的帐户费用',
    WITHDRAWAL_HEADER: '提仓费',
    WITHDRAWAL_TEXTAREA: '按与你的会员/经纪约定的费用。'
  },
  FeesButtonGroup: {
    UPDATE_FEES_BTN: '更新',
    CANCEL_FEES_BTN: '取消',
    RESET_FEES_BTN: '重置为预设'
  },
  FeesConfirmation: {
    CONFIRM_BODY_TEXT: '请确认您愿意更改费率',
    CANCEL_FEES_BTN: '取消',
    UPDATE_SUCCESS: '费用成功更新',
    HEADER: '确认费用变更',
    CONFIRM_FEES_BTN: '确认费用变更'
  },
  FeesTable: {
    SPINNER_TITLE: '费用率 (%)',
    TIER_HEADER: '级别',
    BOUND_HEADER: '上限值',
    RATE_HEADER: '费用率 (%)'
  },
  MdTabs: {
    'Execution Fees': '执行费用',
    'Storage Fees': '仓储费',
    Gold: '黄金',
    Silver: '白银',
    Platinum: '铂金',
    'Private Client': '个人客户',
    'Introducing Broker': '中介商',
    'Full Member': '顶级经纪商'
  },
  MdClientSelect: {
    PLACEHOLDER: '选择或过滤客户'
  },

  MdProductSelect: {
    ALL_METALS: '全部',
    Gold: '黄金',
    Silver: '白银',
    Platinum: '铂金',
    '1 kg Bar': '1公斤条',
    'Austrian Philharmonic': '奥地利维也纳爱乐团币',
    'American Eagle': '美国鹰扬币',
    '100 oz Bar': '100盎司条',
    '10 oz Pool NGD': '10盎司池 NGD',
    'Australian Koala': '澳大利亚树熊币',
    '1/2 oz Pool': '1/2盎司池',
    '100 g Bar': '100克条',
    'American Buffalo': '美国水牛币',
    'Australian Kangaroo': '澳大利亚袋鼠币',
    'Chinese Panda': '中国熊猫币',
    'Australian Kookaburra/Koala': '澳大利亚笑翠鸟/树熊币',
    'Mexican Libertad': '墨西哥自由女神币',
    'Canadian Maple': '加拿大枫叶币',
    'Australian Platypus': '澳大利亚鸭嘴兽币',
    'South African Krugerrand': '南非富格林币',
    '1 oz Pool': '1盎司池',
    '1/2 oz Pool NGD': '1/2盎司池 NGD',
    '10 oz Swiss Bar': '10盎司瑞士条',
    '10 oz Minted Bar': '10盎司锻造条',
    '1 oz Pool GD': '1盎司池 GD',
    '1 oz Pool NGD': '1盎司池 NGD',
    '1 kg Bar 995': '1公斤条995',
    '100 g Cast Bar': '100克铸造条',
    '100 g Swiss Bar': '100克瑞士条',
    'Wholesale AAU 10 kg': '批发AAU 10公斤',
    'Wholesale AAG 25,000 oz': ' 批发AAG 25，000盎司',
    '100 g Cast Bar 9999': '100克铸造条 9999',
    '1 kg Bar 999': '1公斤条 999'
  },
  MdHubSelect: {
    PLACEHOLDER: '选择或者过滤交易中心',
    ALL_HUBS: '所有交易中心',
    'Brisbane' : '布里斯班',
    'Sydney' : '悉尼',
    'Singapore' : '新加坡',
    'Hong Kong' : '香港',
    'New York' : '纽约',
    'London' : '伦敦',
    'Zurich' : '苏黎世',
    'Dubai' : '迪拜',
    'Melbourne' : '墨尔本',
    'Adelaide' : '阿德莱德',
    'Perth' : '珀斯',
    'Shanghai' : '上海',
    'Bangkok' : '曼谷',
    'Istanbul' : '伊斯坦布尔',
    'Auckland' : '奥克兰',
    'BNE': '布里斯班',
    'SYD': '悉尼',
    'SIN': '新加坡',
    'HKG': '香港',
    'NYC': '纽约',
    'LON': '伦敦',
    'ZRH': '苏黎世',
    'DXB': '迪拜',
    'MEL': '墨尔本',
    'ADL': '阿德莱德',
    'PER': '珀斯',
    'SHA': '上海',
    'BKK': '曼谷',
    'IST': '伊斯坦布尔',
    'AKL': '奥克兰'
  },
  MdDropdown: {
    'Export': '导出到',
    'Export to CSV': '导出到CSV'
  },
  AccountStatementContainer:{
    RUN_REPORT: '执行明细报表',
    SELECT_DATE_RANGE: '选择日期范围'
  }
}



// WEBPACK FOOTER //
// ./react/translations/cn.ts